import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Understand the Incident`}</h2>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click twice on the  `}<strong parentName="p">{`Last occurence`}</strong>{` Header. `}</p>
      <p parentName="blockquote"><strong parentName="p">{`Result`}</strong>{`: The “Commit in repository robot-shop by Niklaus Hirt on file robot-shop.yaml” should be at the bottom* `}</p>
    </blockquote>
    <p><img parentName="p" {...{
        "src": "./../images/demo/image.063.png",
        "alt": "image"
      }}></img>{`  `}</p>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`When trying to understand what happened during the incident, I sort the Alerts by occurence. This allows you to understand the chain of events.`}</p>
    <ul>
      <li parentName="ul">{`I can see that the first event was a code change that had been commited to `}<strong parentName="li">{`GitHub`}</strong>{`. When I hover over the description I get the full text.
So it seems that the Development Team has reduced the available memory for the mysql database.`}</li>
    </ul>
    <p>{`Other events are confirming the hypothesis. `}</p>
    <ul>
      <li parentName="ul">{`I can then see the CI/CD process kick in and deploys the code change to the system detected by the Security tool and `}</li>
      <li parentName="ul"><strong parentName="li">{`Instana`}</strong>{` has has detected the memory size change. `}</li>
    </ul>
    <ul>
      <li parentName="ul">{`Then `}<strong parentName="li">{`Functional Selenium Tests`}</strong>{` start failing and `}</li>
      <li parentName="ul"><strong parentName="li">{`Turbonomic`}</strong>{` tries to scale-up the mysql database.`}</li>
      <li parentName="ul"><strong parentName="li">{`Instana`}</strong>{` tells me that the mysql Pod is not running anymore, the replicas are not matching the desired state.`}</li>
    </ul>
    <div style={{
      "pageBreakAfter": "always"
    }}></div>
    <ul>
      <li parentName="ul">{`CloudPak for AIOps has learned the normal, good patterns for logs coming from the applications. The Story contains a `}<strong parentName="li">{`Log Anomaly`}</strong>{` that has been detected in the ratings service that cannot acces the mysql database.`}</li>
    </ul>
    <h2>{`📥 STEP: Metric Anomaly`}</h2>
    <img {...{
      "src": "./../images/demo/image.064.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click on a Alert line that has `}<strong parentName="p">{`ANOMALY:`}</strong>{` in the Type column. Then open the `}<strong parentName="p">{`Metric Anomaly Details`}</strong>{` accordion. `}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <ul>
      <li parentName="ul">{`CloudPak for AIOps is also capable of collecting metrics from multiple sources and detecting `}<strong parentName="li">{`Metric Anomalies`}</strong>{`. It was trained on hundreds or thousands of metrics from the environment and constructs a dynamic baseline (shown in green). The graphic suddenly turns red which relates to detected anomaly when the database is consuming a higher amount of memory than usual.`}</li>
    </ul>
    <img {...{
      "src": "./../images/demo/image.065.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
(1) In `}<strong parentName="p">{`Related Alerts`}</strong>{` select some additional alerts.`}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`You can display several alerts at the same time to better understand the temporal dependencies`}</p>
    <div style={{
      "pageBreakAfter": "always"
    }}></div>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
(2) Select a portion of the graph with your mouse to zoom in`}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`Now let’s zoom in to better see the anomalies`}</p>
    <img {...{
      "src": "./../images/demo/image.066.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Hover over a datapoint to show the before/after values. `}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`I can clearly see that the incident caused the `}<strong parentName="p">{`Latencies`}</strong>{` to skyrocket and the `}<strong parentName="p">{`Transactions per Seconds`}</strong>{` are almost zero. This is yet another confirmation of the source of the problem.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Close the Metric anomaly details view. `}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      